import React, { MouseEventHandler, useCallback, useEffect, useState, useRef } from 'react'
import classNames from 'classnames'
import { GlassCircle } from '@/atoms/GlassCircle'
import { FullscreenIcon } from '@/atoms/Icons/FullscreenIcon'
import { PauseIcon } from '@/atoms/Icons/PauseIcon'
import { PlayIcon } from '@/atoms/Icons/PlayIcon'
import { useBitAngelPlayer } from '@/organisms/BitAngelPlayer/BitAngelPlayerContext'

export const StoryVideoPlayerUI: React.FC = () => {
  const player = useBitAngelPlayer()
  const [isShowControls, setShowControls] = useState<boolean>(false)
  const hideControlsTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  const showControls = useCallback(() => {
    if (!isShowControls) {
      setShowControls(true)
    }
    const timeout = setTimeout(() => {
      if (player.isPlaying) {
        setShowControls(false)
      }
    }, 3000)
    if (hideControlsTimeoutRef.current) {
      clearTimeout(hideControlsTimeoutRef.current)
    }
    hideControlsTimeoutRef.current = timeout
  }, [isShowControls, player.isPlaying])

  useEffect(() => {
    return () => {
      if (hideControlsTimeoutRef.current) {
        clearTimeout(hideControlsTimeoutRef.current)
      }
    }
  }, [])

  const toggleFullscreen: MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation()
    player.toggleFullscreen()
  }

  return (
    <div className="absolute inset-3 z-10" onMouseMove={showControls}>
      <div
        className={classNames('flex flex-col cursor-pointer w-full h-full rounded-2xl', { hidden: !isShowControls })}
        onClick={player.togglePlayback}
      >
        <div className="relative h-full w-full">
          <div className="absolute left-1/2 top-1/2 grow-1 -translate-x-1/2 -translate-y-1/2">
            <GlassCircle size={40}>{player.isPlaying ? <PauseIcon size={20} /> : <PlayIcon size={20} />}</GlassCircle>
          </div>
        </div>
        {!player.hideFullscreen && (
          <div className="mt-auto flex shrink-0 grow-0 items-center">
            <GlassCircle size={40} onClick={toggleFullscreen}>
              <FullscreenIcon />
            </GlassCircle>
          </div>
        )}
      </div>
    </div>
  )
}
